import { useEffect, useMemo, useState } from "react";
import { htmlToText } from "@/components/RichText";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(Math.random() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; }
  return a;
}

export default function WinnerTicker() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/gallery?toolkit=bgjcpt").then((r) => setRows(r.data.winners.filter((w) => w.framed_url))).catch(() => setRows([]));
  }, []);
  const items = useMemo(() => (rows ? shuffle(rows).slice(0, 12) : []), [rows]);

  if (rows === null) return <div className="mt-6 h-64 animate-pulse rounded-3xl bg-sbg-blush/40" />;
  if (items.length === 0) {
    return (
      <div className="mt-6 rounded-3xl bg-white p-10 text-center ring-1 ring-sbg-raspberry/10" data-testid="ticker-empty">
        <p className="font-display text-lg font-bold text-sbg-burgundy md:text-xl">Be the first frame on the wall</p>
        <p className="mt-1 text-sm text-sbg-burgundy/70">As winners create their frames and pages, they'll slide through here.</p>
      </div>
    );
  }
  const loop = items.length < 6 ? [...items, ...items, ...items] : [...items, ...items];
  const duration = Math.max(30, loop.length * 4);
  return (
    <div className="ticker-mask mt-6 overflow-hidden" data-testid="winner-ticker">
      <div className="ticker-track flex w-max gap-5" style={{ animationDuration: `${duration}s` }}>
        {loop.map((w, i) => (
          <Link
            key={`${w.slug}-${i}`}
            to={`/bgjcpt/${w.slug}`}
            data-testid={i < items.length ? `ticker-card-${w.slug}` : undefined}
            className="group w-56 shrink-0 overflow-hidden rounded-3xl bg-white ring-1 ring-sbg-raspberry/10 transition-transform hover:-translate-y-1"
          >
            <img src={w.framed_url} alt={w.name ? `${w.name}'s winner frame` : "Winner frame"} className="aspect-square w-full object-cover" loading="lazy" />
            <div className="p-3">
              <p className="truncate text-sm font-black text-sbg-burgundy">{w.name || "A #BlackGirlJoy Winner"}</p>
              <p className="line-clamp-2 text-xs text-sbg-burgundy/70">{w.project_title || htmlToText(w.project_description) || "Spreading joy in her community"}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
